import comp from "./FeedList";
export default comp;
